import React, { useState, useEffect } from 'react';
import { Breadcrumb, Select, Switch } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import {
  getSpecificDistributionRequest,
  saveDistributionRequest,
} from 'modules/contactModule/requests/contactRequests';
import 'moment/locale/pl';
import { getProvincesRequest } from 'modules/sectionsModule/requests/sectionsRequests';
import FormCoverUpload from '../../galleryModules/components/FormCoverUpload';
const { TextArea } = Input;

const DistributionEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage1Changed, changedFileImage1] = useState<boolean>(false);

  useEffect(() => {
    toggleLoading(true);

    getProvincesRequest().then((response) => {
      if (response) {
        const sections = response.map(
          (section: { name: string; id: number }) => {
            return {
              label: section.name,
              value: section.id,
            };
          }
        );
        setProvinces(sections);
      }
    });

    getSpecificDistributionRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;
          setFields([
            {
              name: ['id'],
              value: data.id,
            },
            {
              name: ['name'],
              value: data.name,
            },
            {
              name: ['city'],
              value: data.city,
            },
            {
              name: ['phone'],
              value: data.phone,
            },
            {
              name: ['description'],
              value: data.description,
            },
            {
              name: ['phone2'],
              value: data.phone2,
            },
            {
              name: ['address'],
              value: data.address,
            },
            {
              name: ['zipcode'],
              value: data.zipcode,
            },
            {
              name: ['email'],
              value: data.email,
            },
            {
              name: ['www'],
              value: data.www,
            },
            {
              name: ['id_province'],
              value: data.id_province,
            },
            {
              name: ['lat'],
              value: data.lat,
            },
            {
              name: ['lon'],
              value: data.lon,
            },
            {
              name: ['isActive'],
              value: data.isActive || false,
            },
            {
              name: ['fileImage1'],
              value: data.image,
            },
          ]);
          form.setFieldsValue({
            fileImage1: data?.image,
          });
          setFileImage1(data?.image);
        } else {
          history.push('/distribution');
        }
      })
      .catch((e) => {
        history.push('/distribution');
      });
  }, []);

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    imageChanged?: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    if (imageChanged) {
      imageChanged(true);
    }
  };

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    saveDistributionRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Kontakt</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/distribution">Punkty dystrybucji</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/distribution/${id}`}>Edycja</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="fileImage1"
                label="Okładka"
              >
                <FormCoverUpload
                  cover={fileImage1}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage1',
                      setFileImage1,
                      changedFileImage1
                    )
                  }
                  isNew={fileImage1Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage1"
                  number={1}
                  hideTags
                />
              </Form.Item>
              <Form.Item
                name="name"
                label="Nazwa"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="id_province"
                label="Województwo"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Wybierz województwo"
                  optionFilterProp="children"
                  options={provinces}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item
                name="address"
                label="Adres"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="city"
                label="Miasto"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="zipcode"
                label="Kod pocztowy"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="phone"
                label="Numer telefonu"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="phone2" label="Numer telefonu 2">
                <Input />
              </Form.Item>
              <Form.Item
                name="email"
                label="Adres e-mail"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="description" label="Opis">
                <TextArea rows={4} />
              </Form.Item>
              <Form.Item name="www" label="Adres www">
                <Input />
              </Form.Item>
              <Form.Item
                name="lat"
                label="Szerokość geograficzna"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="lon"
                label="Długość geograficzna"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/distribution">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/distribution">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default DistributionEdit;
